import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const FileUploadSection = ({ getRootProps, getInputProps, isDragActive, handleFileSelect, loading }) => {
  const { t } = useTranslation();
  return (
    <div className="upload-section">
      <div {...getRootProps()} className={`dropzone${isDragActive ? ' active' : ''}`} data-testid="dropzone" aria-label={t('buttons.upload')}>
        <input {...getInputProps()} />
        <p>{isDragActive ? t('messages.dragActive') : t('messages.dragDrop')}</p>
        {loading && <div className="spinner" aria-label="Loading"></div>}
      </div>
      <div className="file-input-section">
        <button className="upload-button" onClick={handleFileSelect}>{t('buttons.upload')}</button>
      </div>
    </div>
  );
};

FileUploadSection.propTypes = {
  getRootProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  isDragActive: PropTypes.bool.isRequired,
  handleFileSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default FileUploadSection;
